import { createTheme } from '@mui/material/styles';

// Create a theme with Poppins font and disableGutters for Container globally
const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif', // Sets Poppins as the default font
  },
  components: {
    MuiContainer: {
      defaultProps: {
        disableGutters: true, // Globally disables gutters for the Container component
      },
    },
  },
});

export default theme;
